import { render, staticRenderFns } from "./xeroList.vue?vue&type=template&id=611b651a"
import script from "./xeroList.vue?vue&type=script&lang=js"
export * from "./xeroList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports